import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import _ from 'lodash'
import { get } from '../../../../helpers/api_helper'
import { toast } from 'react-toastify'


function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div className='custom-arrow next' onClick={onClick}>
      <i className='bx bx-chevron-right'></i>
    </div>
    // <button
    //   className={`${className}`}
    //   style={{
    //     ...style,

    //     width: '30px',
    //     height: '100px',
    //     borderRadius: '5px',
    //   }}
    //   onClick={onClick}
    // />
  )
}

function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div className='custom-arrow prev' onClick={onClick}>
      <i className='bx bx-chevron-left'></i>
    </div>
    // <button
    //   className={`${className}`}
    //   style={{
    //     ...style,
    //     width: '30px',
    //     height: '100px',
    //     borderRadius: '5px',
    //   }}
    //   onClick={onClick}
    // />
  )
}

const Banner = ({ list }) => {
  const settings = {
    dots: false,
    infinite: true,
    lazyLoad: true,
    fade: true,
    // speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    className: 'myCustomCarousel',
  }

  return (
    <div className='slider-container'>
      <Slider {...settings}>
        {Array.isArray(list) && _.size(list)
          ? list.map((item, index) => {
              return (
                <div className='slide'>
                  <div key={item.id} className='image-container'>
                    <img
                      src={item.document_file}
                      alt={item.altText}
                      className='rounded-4 slide-image'
                    />
                  </div>
                </div>
              )
            })
          : null}
      </Slider>
    </div>
  )
}

export default Banner